/* eslint-disable consistent-return */
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { ModalProps } from "react-bootstrap";
import uuid from "react-uuid";
import PaginationLocal from "../../components/PaginationLocal";
import GenericUtils from "../../utils/GenericUtils";
import TableStyles from "../../styles/components/TableStyles";
import ActivityPlanService from "../../service/Docente/ActivityPlanService";

export interface IActivityPlanHistoric extends ModalProps {
    teachingActivityPlanId: number;
    hideApproverProfile?: boolean;
}

const AcademicActivityPlanHistoric: React.FC<IActivityPlanHistoric> = ({
    teachingActivityPlanId,
}) => {
    const { instance } = useMsal();
    const [filteredData, setFilteredData] = useState<string[]>([]);
    const [info, setInfo] = useState<Array<string>>([""]);

    const getHistoricData = async () => {
        try {
            const response = await ActivityPlanService.getHistoricTACH(
                teachingActivityPlanId,
                instance
            );

            if (GenericUtils.isSuccessStatus(response)) {
                if (response.data.items) {
                    setInfo(response.data.items);
                    setFilteredData(response.data.items);
                }
                return response.data;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    useEffect(() => {
        getHistoricData();
    }, []);

    const formatDate = (date: string) => {
        const dataObjeto = new Date(date);
        const day = dataObjeto.getDate().toString().padStart(2, "0");
        const month = (dataObjeto.getMonth() + 1).toString().padStart(2, "0");
        const year = dataObjeto.getFullYear().toString();

        return `${day}/${month}/${year}`;
    };

    const justificationText = (
        isApproved: boolean,
        isCoordinator: boolean,
        justification: string
    ) => {
        let showJustification = justification;
        if (isApproved && isCoordinator) {
            showJustification = "Aprovado";
        }
        return showJustification;
    };

    const actionFormatText = (text: string): string => {
        if (text === "APROVADO") return "Aprovado";
        if (text === "INCONSISTENTE") return "Inconsistente";
        if (text === "SOLICITAR_AJUSTE") return "Solicitar Ajuste";
        return text;
    };

    const bodyOfTable =
        filteredData &&
        filteredData.map((item: any) => {
            let isCoordinator = false;
            let isApproved = false;

            if (item.acao === "APROVADO") {
                isApproved = true;
            }
            if (item.perfilAprovador === "COORDENADOR DE CURSO") {
                isCoordinator = true;
            }

            return (
                <tr key={uuid()}>
                    <td>{item.nomeAprovador}</td>
                    <td>{item.perfilAprovador}</td>
                    <td>{actionFormatText(item.acao)}</td>
                    <td>{formatDate(item.created)}</td>
                    <td>
                        {justificationText(
                            isApproved,
                            isCoordinator,
                            item.justificativa
                        )}
                    </td>
                </tr>
            );
        });

    return (
        <>
            <TableStyles.TablePrimary
                bordered
                striped
                responsive
                style={{ marginBottom: 0 }}
            >
                <thead>
                    <tr>
                        <th>Nome do Aprovador</th>
                        <th>Perfil</th>
                        <th>Ação</th>
                        <th>Data Ação</th>
                        <th>Justificativa</th>
                    </tr>
                </thead>
                <tbody>
                    {info.length === 0 ? (
                        <tr>
                            <td colSpan={5}>Informações indisponíveis.</td>
                        </tr>
                    ) : (
                        bodyOfTable
                    )}
                </tbody>
            </TableStyles.TablePrimary>
            <PaginationLocal
                items={info}
                itemsPage={10}
                onPaginate={(data) => setFilteredData(data)}
                hidePagination={false}
            />
        </>
    );
};

export default AcademicActivityPlanHistoric;
